import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle,withState } from 'recompose'
import ReactTable from 'react-table'
import { Button } from 'semantic-ui-react'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'

import { TableContainer, TableContent, ListRecordsContent, ViewDataPatternContent } from './styled'
import Pagination from '../Pagination'
import 'react-table/react-table.css'

const Table = (props) => {
  const { data, columnsTable, columnsList, pageSizeU, showTable } = props

  return (
    <TableContainer>
      <ViewDataPatternContent>
        {props.customFilterTop}
        <Button.Group>
          <Button 
            icon
            className={`patternButton${showTable ? '' : ' active'}`}
            onClick={() => props.onChangeTableType(false)} 
          >
            <Icon icon='list' />
          </Button>
          <Button 
            icon
            className={`patternButton${showTable ? ' active' : ''}`}
            onClick={() => props.onChangeTableType(true)}
          >
            <Icon icon='table' />
          </Button>
        </Button.Group>
      </ViewDataPatternContent>
      {
        showTable ? 
        <TableContent>
          <ReactTable 
            data={data}
            columns={columnsTable}
            PaginationComponent={Pagination}
            pageSize={pageSizeU}
            previousText='previous'
            nextText='next'
          />
        </TableContent> :
        <ListRecordsContent>
          <ReactTable 
            data={data}
            columns={columnsList}
            PaginationComponent={Pagination}
            minRows = {0}
            pageSize={pageSizeU}
            previousText='previous'
            nextText='next'
          />
        </ListRecordsContent>
      }
    </TableContainer>
  )
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = {
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  connect((state, props) => ({
    history: props.history
  })),
  withState('pageSizeU','setPageSizeU',0),
  lifecycle({
    componentDidMount() {
    },
    componentWillReceiveProps(nextProps) {
      if (this.props.pageSizeU !== nextProps.pageSize) {
        this.props.setPageSizeU(nextProps.pageSize)
      }
    }
  })
)

export default enhance(Table)